import { useMediaQuery } from '@mui/material';

export default function useIsPrint(): boolean {
  return useMediaQuery('print');
}
